"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var components_lib_1 = require("@dynamynd/components-lib");

var formik_1 = require("formik");

var moment_1 = __importDefault(require("moment"));

var react_1 = __importStar(require("react"));

var __1 = require("..");

var __2 = require("../..");

var AuthStyled_1 = require("../styled/AuthStyled");

exports.BirthdatePicker = function (_a) {
  var DateInputComponent = _a.DateInputComponent,
      activeBreakpoint = _a.activeBreakpoint,
      _onSubmit = _a.onSubmit,
      setPageTitle = _a.setPageTitle; // boolean to check if the birthdate is fewer than 13 years from now

  react_1.useEffect(function () {
    setPageTitle('What is your Birthdate?');
  }, []);
  var buttonProps = {
    type: components_lib_1.ButtonTypeEnum.primary,
    text: 'Continue to Create an Account'
  };
  return react_1.default.createElement(formik_1.Formik, {
    initialValues: {
      dateOfBirth: ''
    },
    onSubmit: function onSubmit(_a, _b) {
      var dateOfBirth = _a.dateOfBirth;
      var setSubmitting = _b.setSubmitting;
      setSubmitting(true);

      _onSubmit(dateOfBirth);
    },
    render: function render(props) {
      return react_1.default.createElement(components_lib_1.ColumnCentered, null, react_1.default.createElement(AuthStyled_1.FormInputGroup, null, react_1.default.createElement(components_lib_1.FormFieldContainer, null, react_1.default.createElement(components_lib_1.FormField, __assign({}, props, {
        name: __2.FieldNames.dateOfBirth
      }), react_1.default.createElement(components_lib_1.StyledInputLabel, null, __2.FieldLabels.dateOfBirth), react_1.default.createElement(formik_1.Field, {
        name: __2.FieldNames.dateOfBirth,
        label: __2.FieldLabels.dateOfBirth,
        activeBreakpoint: activeBreakpoint,
        component: DateInputComponent,
        onChange: function onChange(bdate) {
          props.setFieldValue(__2.FieldNames.dateOfBirth, bdate, true);
        },
        validate: function validate(value) {
          return moment_1.default(value).isValid() ? undefined : 'Please enter a valid date';
        }
      })))), react_1.default.createElement(__1.AuthButtonsContainer, null, react_1.default.createElement(__1.StepButtonsWrapper, {
        activeBreakpoint: activeBreakpoint
      }, react_1.default.createElement(components_lib_1.Button, __assign({}, buttonProps, {
        uppercase: true,
        onPress: props.handleSubmit,
        disabled: !props.isValid,
        accessibilityLabel: "Continue to Create an Account"
      })))));
    }
  });
};